import { ContactsApiProvider } from './contactsapi.services';

export const fetchMember = (memberKey) => {
  return ContactsApiProvider.get(`/members/${memberKey}?embed=ScoreHistory`);
};

export const fetchOffice = (officeKey) => {
  return ContactsApiProvider.get(`/offices/${officeKey}`);
};

export const fetchNotifications = (memberKey) => {
  return ContactsApiProvider.get(`/members/${memberKey}/notificationlogs`);
};

export const fetchPersonSettings = (memberKey) => {
  return ContactsApiProvider.get(`/members/${memberKey}/settings`);
};

export const updatePersonSettings = (memberKey, personSetting) => {
  return ContactsApiProvider.put(`/members/${memberKey}/settings`, personSetting);
};
